// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDyH9rXWwSL3iA6i-MufTbzNtMB703XCFw",
  authDomain: "test-b3382.firebaseapp.com",
  projectId: "test-b3382",
  storageBucket: "test-b3382.appspot.com",
  messagingSenderId: "998658113627",
  appId: "1:998658113627:web:af6531d2680ba665733f7e",
  measurementId: "G-7G2XN1FHDP"
};

export default firebaseConfig;